import { createStore, applyMiddleware } from 'redux';
import { createBrowserHistory } from 'history';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { routerMiddleware } from 'connected-react-router';

import { createMiddleware } from 'redux-beacon';
import GoogleTagManager from '@redux-beacon/google-tag-manager';

import createSagaMiddleware from 'redux-saga';
import createRootReducer from './modules/RootReducer';
import rootSagas from './modules/rootSagas';
import eventsMap from './modules/gtm/eventsMap';
import storyOrTest from './utility/tools/storyOrTest';

const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();
const gtm = GoogleTagManager();
const gtmMiddleware = createMiddleware(eventsMap, gtm);

const middlewares = [
	routerMiddleware(history),
	sagaMiddleware,
	// We don't want GTM middleware injected in our tests or stories
	!storyOrTest() && gtmMiddleware,
].filter(Boolean);

const store = createStore(
	createRootReducer(history),
	composeWithDevTools(applyMiddleware(...middlewares)),
);

sagaMiddleware.run(rootSagas);

export { store, sagaMiddleware };
export { history };
